import DeviceCard from "./DeviceCard"
import removeIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png'

const EfentoCard = ({efento, pinObject}) => {

    const sensorType = "Knowio sensor"
    const sensorID = efento.type.split(" ")

    const unlink = () => {

    }
    
    return (
        <DeviceCard
            header={`${sensorType}`}
            meta={[sensorID[2]]}
            rightContent={
            <>
                <h3 style={{color:"var(--Primary-Color)"}}>{pinObject.pinName}</h3>
                <img src={removeIcon} style={{width:"25px"}} onClick={() => unlink()} />
            </>
            }
        />
        );
}

export default EfentoCard;